import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import _ from 'lodash';

export const SpinnerComponent = ({ customStyle }) => (
  <div className="ml-3">
    <img
      id="spinner-img"
      src="assets/ajax_loader_66.gif"
      alt="Loading..."
      style={customStyle}
      {...(_.isNil(customStyle) && { className: classNames(styles.spinner) })}
    />
  </div>
);
